import React from "react";
import { Checkbox } from "@atlaskit/checkbox";
import { Expandable } from "../Collapse/Expandable";
import { createKey, eventTypeBackColor } from "../../../helpers/helpers";
import Lozenge from "@atlaskit/lozenge";
import Skeleton from "react-loading-skeleton";
import styles from "./WrapperRestore.module.css";
import Avatar from "@atlaskit/avatar";

export const TableWrapper = ({ children }) => (
  <div className={styles.tableWrapperStyles}>{children}</div>
);
export const NameWrapper = ({ children }) => (
  <span className={styles.nameWrapperStyles}>{children}</span>
);

export const AvatarWrapper = ({ children }) => (
  <div className={styles.avatarWrapperStyles}>{children}</div>
);

export const createHead = (
  withWidth,
  handleCheckboxCheckAll,
  isLoading,
  globalCheckState
) => {
  return {
    cells: [
      {
        content: (
          <Checkbox
            isDisabled={globalCheckState.disabled || isLoading}
            isChecked={globalCheckState.allChecked}
            isIndeterminate={globalCheckState.indeterminate}
            value="All"
            name="parent"
            type="checkbox"
            onChange={(e) => handleCheckboxCheckAll(e)}
          />
        ),
        key: "selectRow",
        isSortable: false,
        width: withWidth ? 10 : undefined,
      },
      {
        content: "Key",
        key: "key",
        isSortable: false,
        width: withWidth ? 25 : undefined,
      },
      {
        content: "Issue Type",
        key: "issueType",
        isSortable: false,
        width: withWidth ? 40 : undefined,
      },
      {
        content: "Summary",
        key: "summary",
        isSortable: false,
        width: withWidth ? 80 : undefined,
      },
      {
        content: "Description",
        key: "description",
        isSortable: false,
        width: withWidth ? 80 : undefined,
      },
      {
        content: "Assignee",
        key: "assignee",
        isSortable: false,
        width: withWidth ? 60 : undefined,
      },
      {
        content: "Reporter",
        key: "reporter",
        isSortable: false,
        width: withWidth ? 60 : undefined,
      },
      {
        content: "Status",
        key: "status",
        isSortable: false,
        width: withWidth ? 40 : undefined,
      },

      // {
      //   content: "Fields To Be Restored",
      //   key: "fieldsResored",
      //   isSortable: false,
      //   width: withWidth ? 100 : undefined,
      // },
      // {
      //   content: "Field Values",
      //   key: "fieldValuesInBackup",
      //   isSortable: false,
      //   width: withWidth ? 100 : undefined,
      // },
    ],
  };
};

export const createCells = (
  previewData,
  handleCheckboxCheck,
  tempCheckedItems,
  checkedIssues
) =>
  previewData.map((data, index) => ({
    key: `row-${index}-${data.issueId}`,
    cells: [
      {
        key: createKey("selectRow"),
        content: (
          <Checkbox
            key={data.issueId}
            isDisabled={
              data.blockrestore === "false" ||
              (tempCheckedItems[data.issueId] !== true &&
                checkedIssues.length > 49)
                ? true
                : false
            }
            isChecked={
              tempCheckedItems !== [] ? tempCheckedItems[data.issueId] : false
            }
            name={data.issueId}
            onChange={(e) => {
              handleCheckboxCheck(e, data);
            }}
          />
        ),
      },
      {
        // key: createKey(data.key),
        key: createKey(data.issueKey),
        // content: data.key,
        content: data.issueKey,
      },
      {
        // key: createKey(data.issuetype),
        // content: (
        //   <NameWrapper>
        //     <AvatarWrapper>
        //       <img
        //         className={styles.avatar}
        //         src={data.fields.issuetype.backupValue.iconUrl}
        //         width="16px"
        //         height="16px"
        //         alt=""
        //       ></img>
        //     </AvatarWrapper>
        //     {data.issuetype}
        //   </NameWrapper>
        // ),
        key: createKey(data.issueTypeName),
        content: data.issueTypeName,
      },
      {
        key: createKey(data.summary),
        content: data.summary,
      },
      {
        key: createKey("Description"),
        // content: <Expandable fields={data.fields} />,
        content: <Expandable description={data.description} />,
      },
      {
        key: createKey("Assignee"),
        content:
          data.assigneeId && data.assigneeId !== "-" ? (
            data.assigneeName === "Not found" ? (
              data.assigneeId
            ) : (
              <NameWrapper>
                <AvatarWrapper>
                  <Avatar
                    src={data.assigneeAvatar}
                    name={"USername"}
                    size="small"
                  />
                </AvatarWrapper>
                {data.assigneeName === "-" ? (
                  <Skeleton
                    width={"150px"}
                    count={1}
                    baseColor="lightgrey"
                    height={"10px"}
                  />
                ) : (
                  data.assigneeName
                )}
              </NameWrapper>
            )
          ) : (
            <>-</>
          ),
      },
      {
        key: createKey("Reporter"),
        content:
          data.reporterId && data.reporterId !== "-" ? (
            data.reporterName === "Not found" ? (
              data.reporterId
            ) : (
              <NameWrapper>
                <AvatarWrapper>
                  <Avatar
                    src={data.reporterAvatar}
                    name={"USername"}
                    size="small"
                  />
                </AvatarWrapper>
                {data.reporterName === "-" ? (
                  <Skeleton
                    width={"150px"}
                    count={1}
                    baseColor="lightgrey"
                    height={"10px"}
                  />
                ) : (
                  data.reporterName
                )}
              </NameWrapper>
            )
          ) : (
            <>-</>
          ),
      },
      {
        // key: createKey(data.status),
        // content: (
        //   <Lozenge
        //     style={{
        //       backgroundColor: eventTypeBackColor(data.status),
        //       color: "#000",
        //     }}
        //     isBold
        //   >
        //     {data.status}
        //   </Lozenge>
        // ),
        key: createKey(data.issueStatusName),
        content: (
          <Lozenge
            style={{
              backgroundColor: eventTypeBackColor(data.issueStatusName),
              color: "#000",
            }}
            isBold
          >
            {data.issueStatusName}
          </Lozenge>
        ),
      },

      // {
      //   key: createKey("fieldRestore"),
      //   content: <Expandable fields={data.fields} />,
      //   colSpan: 2,
      // },
      // {
      //   key: createKey("fieldRestore"),
      //   content: <Expandable fields={data.fields} id={data.issueId} />,
      //   colSpan: 3,
      // },
      // {
      //   key: createKey("fieldValues"),
      //   content: "Multiple Values",
      // },
    ],
  }));
